<template>
  <div>
    <nav-bar />
    <result :result="result" :list_id="list_id" />
    <b-container>
      <template v-if="step == 1">
        <b-row align-v="center">
          <b-col cols="auto">
            <v-btn class="btn-return" @click="$router.go(-1)">
              <i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar
            </v-btn>
          </b-col>
          <b-col>
            <h1 class="title-pages">RESPONDER LISTAS</h1>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h6 class="mb-0 upper-text">Lista:</h6>
            <b-overlay :show="loading" opacity="0.99">
              <v-select
                label="SELECIONE..."
                item-text="description"
                class="mb-2"
                dense
                hide-details
                outlined
                return-object
                :disabled="loading"
                :items="lists"
                v-model="selected_list"
                @input="filterResidentsByFormVisibilty"
              />
              <h6 class="mb-0 upper-text">Residentes:</h6>
              <v-text-field
                placeholder="PESQUISAR RESIDENTE"
                class="mb-2"
                v-model="search_resident"
                :disabled="loading"
                dense
                hide-details
                outlined
              />
              <v-data-iterator
                must-sort
                sort-by="name"
                :search="search_resident"
                :items-per-page="5"
                :sort-desc="false"
                :items="residents"
              >
                <template #header v-if="residents.length > 0">
                  <div class="bg-white mb-1 p-1">
                    <b-checkbox
                      :disabled="search_resident.length > 0"
                      :checked="selected_residents.length == residents.length"
                      @change="toggleAll"
                      class="text-fourteen"
                    >
                      {{
                        residents.some((r) => !r.selected)
                          ? "SELECIONAR TODOS"
                          : "DESMARCAR TODOS"
                      }}
                    </b-checkbox>
                  </div>
                </template>
                <template v-slot:default="{ items }">
                  <div class="p-1">
                    <b-checkbox
                      class="text-fifteen bottom-border"
                      v-for="item in items"
                      :key="item.id"
                      :checked="item.selected"
                      @change="toggleResident(item, $event)"
                    >
                      {{ item.name.toUpperCase() }}
                    </b-checkbox>
                  </div>
                </template>
                <template #no-data>
                  <div class="v-clean p-5 text-center">
                    <h6 class="text-center upper-text worksansr">
                      SEM RESULTADOS!
                    </h6>
                  </div>
                </template>
                <template #no-results>
                  <div class="v-clean p-5 text-center">
                    <h6 class="text-center upper-text worksansr">
                      SEM RESULTADOS!
                    </h6>
                  </div>
                </template>
              </v-data-iterator>
            </b-overlay>
          </b-col>
        </b-row>
        <b-row align-h="end">
          <b-col cols="auto">
            <v-btn
              class="btn-acess ml-2"
              @click="nextStep"
              :disabled="
                loading || !selected_list || selected_residents.length == 0
              "
            >
              RESPONDER <i class="fas fa-arrow-right ml-2 text-twenty" />
            </v-btn>
          </b-col>
        </b-row>
      </template>
      <template v-if="step == 2">
        <answer-list
          :list="selected_list"
          :residents="selected_residents"
          @return="evOnReturn"
        />
      </template>
    </b-container>
  </div>
</template>

<script>
import api from "../services/api";

import AnswerList from "../templates/AnswerLists/AnswerList.vue";

import Result from "../templates/AnswerLists/Result.vue";

import NavBar from "../templates/NavBar.vue";

export default {
  name: "AnswerLists",
  components: { NavBar, AnswerList, Result },
  data() {
    return {
      errors: [],
      loading: false,
      step: 1,

      result: undefined,

      lists: [],
      list_id: "",
      selected_list: undefined,

      all_residents: [],
      headers: [{ text: "Nome", value: "name" }],
      residents: [],
      search_resident: "",
      selected_residents: [],
    };
  },
  created() {
    this.getLists();
    this.getResidents();
  },

  methods: {
    async toggleAll(value) {
      for (let resident of this.residents) resident.selected = value;

      await this.updateSelected();
    },

    async toggleResident(resident, value) {
      resident.selected = value;

      await this.updateSelected();
    },

    async updateSelected() {
      this.selected_residents = [
        ...this.residents.filter((resident) => resident.selected),
      ];
    },

    async getLists() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/lists/all");
        const { error, errors, lists } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.lists = lists;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getResidents() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/active-residents");
        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.all_residents = residents;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async filterResidentsByFormVisibilty() {
      if (this.selected_list) {
        this.list_id = this.selected_list.id;
      }

      this.residents = this.all_residents.map((resident) => ({
        selected: false,
        ...resident,
      }));
    },

    async nextStep() {
      this.step = 2;
    },

    async evOnReturn(result) {
      this.step = 1;
      this.selected_list = undefined;
      this.residents = [];
      this.selected_residents = [];
      this.result = result;
    },
  },
};
</script>

<style>
</style>